import { useCallback, useEffect, useState } from "react";
import { message } from "antd";
import { useSelector } from "react-redux";
import { getCategories, updateCategory, updateCategoryStatus } from "../../api/Categories";
import { selectUser } from "../../redux/slices/user";
import CategoriesUI from "./components/CategoriesUI";

const Categories = () => {
  const user = useSelector(selectUser);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const [visibleEditor, setVisibleEditor] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const initialFetch = useCallback(async () => {
    setLoading(true);
    const response = await getCategories();

    if (!response.error && response.status === 200) {
      setCategories(response.data?.categories || response.data || []);
    } else {
      message.error("¡Hubo un problema al cargar las categorías!");
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    initialFetch();
  }, [initialFetch]);

  const openEditor = (category) => {
    setSelectedCategory(category);
    setVisibleEditor(true);
  };

  const closeEditor = () => {
    setVisibleEditor(false);
    setSelectedCategory(null);
  };

  const handleStatusChange = async (categoryId, currentValue, mode) => {
    const nextValue = Number(!Number(currentValue));

    const estado_nombre = nextValue == 1? 'activada':'desactivada';
    setCategories((prevCategories) =>
      prevCategories.map((category) =>
        category.id === categoryId ? { ...category, [mode]: nextValue } : category
      )
    );

    const response = await updateCategoryStatus({
      id_category: categoryId,
      mode,
      active: nextValue,
      userId: user.id,
    });

    if (!response.error && response.status === 200) {
      message.success(`Categoría ${estado_nombre} correctamente`);
      return;
    }

    setCategories((prevCategories) =>
      prevCategories.map((category) =>
        category.id === categoryId ? { ...category, [mode]: currentValue } : category
      )
    );
    message.error("¡Hubo un problema al actualizar el estado!");
  };

  const handleSave = async ({ id, name, image1, image2 }) => {
    const payload = new FormData();

    payload.append("id_category", id);
    payload.append("name", name);
    payload.append("userId", user.id);
    payload.append("image1", image1 || "");
    payload.append("image2", image2 || "");
    
    const response = await updateCategory(payload);

    if (!response.error && response.status === 200) {
      message.success("Categoría actualizada con éxito");
      closeEditor();
      await initialFetch();
      return { status: "success" };
    }

    message.error("¡Hubo un problema al guardar la categoría!");
    return { status: "error" };
  };

  return (
    <CategoriesUI
      loading={loading}
      categories={categories}
      visibleEditor={visibleEditor}
      selectedCategory={selectedCategory}
      openEditor={openEditor}
      closeEditor={closeEditor}
      handleStatusChange={handleStatusChange}
      handleSave={handleSave}
    />
  );
};

export default Categories;
